import { render, staticRenderFns } from "./QuoteDefaults.vue?vue&type=template&id=b966d15c&"
import script from "./QuoteDefaults.vue?vue&type=script&lang=js&"
export * from "./QuoteDefaults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports